export default __webpack_public_path__ + "static/media/346.95f37896.jpg";